// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ctg-grid {
  display: grid;
  width: 100%;
  font-size: 13px;
}

.ctg-header-cell {
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #6b6b6b;
  background: #fafafa;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.ctg-cell {
  padding: 14px 20px;
  color: #0b0b0b;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}

.ctg-cell:hover {
  background: #fafafa;
}

/* ── Dark theme ── */
.dark .ctg-header-cell {
  color: #94a3b8;
  background: #1e293b;
  border-top-color: #334155;
  border-bottom-color: #334155;
}

.dark .ctg-cell {
  color: #f1f5f9;
  border-bottom-color: #334155;
}

.dark .ctg-cell:hover {
  background: #0f172a;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/CustomTableGrid/CustomTableGrid.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".ctg-grid {\n  display: grid;\n  width: 100%;\n  font-size: 13px;\n}\n\n.ctg-header-cell {\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b6b6b;\n  background: #fafafa;\n  border-top: 1px solid #e6e6e6;\n  border-bottom: 1px solid #e6e6e6;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.ctg-cell {\n  padding: 14px 20px;\n  color: #0b0b0b;\n  border-bottom: 1px solid #f5f5f5;\n  display: flex;\n  align-items: center;\n}\n\n.ctg-cell:hover {\n  background: #fafafa;\n}\n\n/* ── Dark theme ── */\n.dark .ctg-header-cell {\n  color: #94a3b8;\n  background: #1e293b;\n  border-top-color: #334155;\n  border-bottom-color: #334155;\n}\n\n.dark .ctg-cell {\n  color: #f1f5f9;\n  border-bottom-color: #334155;\n}\n\n.dark .ctg-cell:hover {\n  background: #0f172a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
